import { axiosInstanceWithAuth } from '../../../services/axios-instance';

export interface AdServiceParams {
  page?: number;
  value?: string;
  take?: number;
  id?: string;
  type?: any;
}

export const AdServicesFilter = {
  getAdlistFilter: async (querySearch: AdServiceParams) => {
    const { page, value, take, id, type } = querySearch;
    const filter = value ? `&filter=${value}` : '';
    const takePage = take ? `&take=${take}` : '';
    const idWhenAdmin = id ? `&userId=${id}` : '';
    const vehicleType = type ? `&type=${type}` : '';

    return await axiosInstanceWithAuth
      .get(`advertisement/findByUser/?page=${page}${filter}${takePage}${vehicleType}${idWhenAdmin}`)
      .then(resp => resp)
      .catch(err => err);
  },

  getPartServicesFilter: async (querySearch: AdServiceParams) => {
    const { page, value, take, id } = querySearch;
    const search = value ? `&search=${value}` : '';
    const takePage = take ? `&take=${take}` : '';
    const idWhenAdmin = id ? `&userId=${id}` : '';

    return await axiosInstanceWithAuth
      .get(
        `/advertisement/partServices/findPartsByUser/?page=${page}${search}${takePage}${idWhenAdmin}`,
      )
      .then(resp => resp)
      .catch(err => err);
  },
};

export const DeleteAdServices = {
  deleteAd: async (id: any) =>
    await axiosInstanceWithAuth
      .delete(`/advertisement/${id}`)
      .then(resp => resp)
      .catch(err => err),

  deletePardAd: async (id: any) =>
    await axiosInstanceWithAuth
      .delete(`/advertisement/parts/${id}`)
      .then(resp => resp)
      .catch(err => err),
};
